import React from "react";
import { useLocation } from "react-router-dom";

const NavLink = ({ link, title, icon }) => {
	const location = useLocation();
	return (
		<a
			href={link}
			className={`${
				location.pathname === link
					? "bg-slate-700/50 text-white"
					: "text-slate-300 hover:bg-slate-700/30"
			} px-4 py-2 flex items-center gap-3 rounded-lg transition-all duration-300`}
		>
      <span className={location.pathname === link ? "text-white" : "text-slate-400"}>
        {icon}
      </span>
			<span className="font-medium">{title}</span>
		</a>
	);
};

export default NavLink;
